import { render, staticRenderFns } from "./UnavailableDeviceFeedback.vue?vue&type=template&id=8a8c2764&scoped=true"
import script from "./UnavailableDeviceFeedback.vue?vue&type=script&lang=js"
export * from "./UnavailableDeviceFeedback.vue?vue&type=script&lang=js"
import style0 from "./UnavailableDeviceFeedback.vue?vue&type=style&index=0&id=8a8c2764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8c2764",
  null
  
)

export default component.exports